import {
  faArrowsRotate,
  faGlobe,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Group, Paper, Stack, Text, Title } from '@mantine/core'
import { FC, useState } from 'react'
import { TransactionItem } from '../../models/Transactions/TransactionItem'
import { COLORS } from '../../utils/constants'
import { formatNumber } from '../../utils/displayUtils'
import { AdvertisementDetailsModal } from './AdvertisementDetailsModal'

interface TransactionItemCardProps {
  item: TransactionItem
}

const getStatusBadge = (status: string) => {
  return <Badge color={status === 'PAID' ? 'green' : 'yellow'}>{status}</Badge>
}

const TransactionItemCard: FC<TransactionItemCardProps> = ({ item }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleCardClick = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <Paper
        p='md'
        pt='sm'
        withBorder
        radius='md'
        shadow='xs'
        style={{ cursor: !item.isDesignRequest ? 'pointer' : 'default' }}
        onClick={!item.isDesignRequest ? handleCardClick : undefined}
      >
        <Group justify='space-between' align='flex-start' p='xs' py={0}>
          <Stack gap={0}>
            <Title order={2} fw={300} c={COLORS.LightGreen}>
              {item.name}
            </Title>
            <Group>
              <FontAwesomeIcon
                icon={item.isAllLocations ? faGlobe : faLocationDot}
                color={COLORS.LightGreen}
                size='lg'
              />
              <Title order={3} fw={400}>
                {item.isAllLocations
                  ? `All Locations${item.locationCount != null ? ` (${item.locationCount})` : ''}`
                  : item.location}
              </Title>
            </Group>
          </Stack>
          <Stack gap={2} justify='flex-start' align='flex-end'>
            <Group gap='sm'>
              {getStatusBadge(item.status)}
              <Group gap={4}>
                {item.isAutoRenewal && (
                  <FontAwesomeIcon
                    icon={faArrowsRotate}
                    color={COLORS.LightGreen}
                    size='lg'
                  />
                )}
                <Text fw={700} fz='lg'>
                  ${formatNumber(item.amount)}
                </Text>
              </Group>
            </Group>
            {item.paymentDate ? (
              <Text size='sm'>{item.paymentDate}</Text>
            ) : (
              <Text>Payment will process when ad is approved</Text>
            )}
            {item.nextPaymentDate && (
              <Text size='xs' c='dimmed'>
                Next Payment: {item.nextPaymentDate}
              </Text>
            )}
          </Stack>
        </Group>
      </Paper>

      <AdvertisementDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        advertisement={item}
      />
    </>
  )
}

export default TransactionItemCard
